const preguntasFrecuentesInitialState = {
    preguntasFrecuentes: {
        loading: false,
        error: null,
        data: null
    },
};

export default preguntasFrecuentesInitialState;